import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { MatButton } from '@angular/material/button'
import {
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { NgIf } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatTooltip } from '@angular/material/tooltip'
import { MatDividerModule } from '@angular/material/divider'

@Component({
  selector: 'table-list-tariff',
  imports: [
    MatButton,
    MatTableModule,
    MatIcon,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    MatTooltip,
    MatDividerModule,
  ],
  templateUrl: './table-list-tariff.component.html',
  styleUrl: './table-list-tariff.component.scss',
})
export class TableListTariffComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Output() selectItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Output() viewItinerariesItem = new EventEmitter<any>()
  @Output() changeStatusItem = new EventEmitter<any>()

  @ViewChild('mat-table') table: MatTable<any> | undefined

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource']) {
      this.updateTableDataSource()
    }
  }

  refreshTable() {
    if (this.table) {
      this.table.renderRows()
    }
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
    this.refreshTable()
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }

  viewItinerariesItemEvent(item: any): void {
    this.viewItinerariesItem.emit(item)
  }

  changeStatusItemEvent(item: any): void {
    this.changeStatusItem.emit(item)
  }
}
